export const common = {
  it: {
    greeting: "Ciao, sono Victor Lazari",
    subtitle: "Creo software AI-driven e automazioni per aziende scalabili",
    downloadCV: "Scarica il CV",
    contact: "Contattami",
    about: {
      title: "Chi Sono",
      description: "Ingegnere del software specializzato in AI e automazione. Sviluppo soluzioni che trasformano i dati in valore."
    },
    expertise: {
      ai: "Soluzioni Software AI",
      automation: "Automazione & Business Intelligence",
      prototyping: "Rapid Prototyping & AI Integration",
      machineLearning: "Machine Learning"
    },
    blog: {
      title: "Blog & Articoli",
      backToList: "Torna alla lista",
      readMore: "Leggi l'articolo"
    },
    demoLogin: {
      title: "Accesso demo in corso",
      description: "Sto aprendo il CRM Launch con l'utenza condivisa.",
      signingIn: "Accesso automatico in corso…",
      resetting: "Ripristino dei dati demo…",
      successRedirect: "Reindirizzamento alla dashboard…",
      errorMessage: "Non sono riuscito ad accedere automaticamente.",
      manualHint: "Puoi riprovare più tardi oppure usare le credenziali demo manualmente.",
      manualCta: "Vai al login manuale"
    }
  },
  en: {
    greeting: "Hello, I'm Victor Lazari",
    subtitle: "I create AI-driven software and automation for scalable businesses",
    downloadCV: "Download CV",
    contact: "Contact Me",
    about: {
      title: "About Me",
      description: "Software engineer specializing in AI & automation. I develop solutions that turn data into business value."
    },
    expertise: {
      ai: "AI Software Solutions",
      automation: "Automation & Business Intelligence",
      prototyping: "Rapid Prototyping & AI Integration",
      machineLearning: "Machine Learning"
    },
    blog: {
      title: "Blog & Articles",
      backToList: "Back to list",
      readMore: "Read article"
    },
    demoLogin: {
      title: "Signing you into the demo",
      description: "Opening the Launch CRM sandbox with the shared account.",
      signingIn: "Automatic login in progress…",
      resetting: "Refreshing the sandbox data…",
      successRedirect: "Redirecting to the dashboard…",
      errorMessage: "We couldn’t sign in automatically.",
      manualHint: "You can try again later or enter the demo credentials manually.",
      manualCta: "Go to manual login"
    }
  }
};